module.exports = __webpack_public_path__ + "static/media/fa-regular-400.e07d9e40.woff2";